import React from "react";
import logo from "../../images/logo.png";

const FollowersListModal = ({
  isOpen,
  handleShareToFollowers,
  handleShareCancel,
  children,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed z-50 inset-0 overflow-y-auto">
      <div className="absolute inset-0 bg-black opacity-75"></div>
      <div className="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
        <div className="fixed inset-0 transition-opacity" aria-hidden="true">
          <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
        </div>
        <span
          className="hidden sm:inline-block sm:align-middle sm:h-screen"
          aria-hidden="true"
        >
          &#8203;
        </span>
        <div className="px-2 fixed z-50 inset-0 overflow-y-auto flex items-center justify-center">
          <div className="bg-white rounded-lg w-full shadow-xl max-w-lg mx-auto sm:my-8 p-6 relative">
            {/* Close Modal Cross */}
            <button
              className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
              onClick={handleShareCancel}
            >
              <svg
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>

            {/* Logo */}
            <div className="flex justify-center items-center mb-4">
              <img
                src={"/qushi_logo.png"}
                alt="Logo"
                className="h-16 w-auto"
              />
            </div>
            <h2 className="text-lg font-bold text-primaryColor mb-4">
              Select Followers To Share Chart
            </h2>
            {children}
            <div className="flex align-center justify-center items-center">
              <button
                className="bg-primaryColor hover:bg-primaryColor text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                onClick={handleShareCancel}
              >
                Done
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FollowersListModal;